import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

import warehouse from "../../../assets/images/warehouse/1.png";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-accessible-accordion/dist/fancy-example.css";
import SetHeader from "../../../_components/_common/Header/SetHeader";
import CompareWarehouseList from "../../../_components/_webapp/CompareWarehouseList/CompareWarehouseList";
import CompareList from "../../../_components/_webapp/CompareList/CompareList";
import LoginSignupBanner from "../../../_components/_webapp/MainBanner/LoginSignupBanner";
import "./CompareWarehouse.css";
import { whService } from "../../../_services/Warehouse/warehouseService";
import { connect } from "react-redux";
import toastr from "toastr";
import { setFieldData } from "../../../_helpers/Common/helper";
import { UserDataActions } from "../../../_actions/userData.action";
import compareParameters from "./Parameters";
import isLogin from "../../../_helpers/Common/helper";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import { withRouter } from "react-router-dom";
import LoaderWithLogo from "../../../_components/Loader/LoaderWithLogo";
import { FetchOption } from "../../../_services/CommnService/OptionService/FetchOption";
import { optionActions } from "../../../_actions/option.actions";
import { Link } from "react-router-dom";
import { compareConstant } from "../../../_constants/Config/compareConfig";
import { AiOutlineMinus, AiOutlinePlus, AiOutlineRight } from "react-icons/ai";
import MultiCarousel from "../../../_components/_common/MultiCarousel/MultiCarousel";
import notfound from "../../../assets/images/main-home/warehouse.jpg";
import WebFooter from "../../../_components/_webapp/Footer/WebFooter";
const capacity_wh = [
  { value: "Area", key: "area_in_sqft" },
  { value: "Capacity", key: "warehouse_capacity" },
  { value: "No. Bags (50 Kg Per Bag)", key: "no_of_bags" },
  { value: "Area(l*b*h)", key: "dimensions" },
];

const accessibility_wh = {
  apmc_name: "Closet APMC and its distance",
  rakepoint_name: "Rake point and distance",
  apmc_under_40_km: "No. of AMPC (Under 40kms Radius)",
  railway_station_distance: "Nearest Railway Station",
  fire_station_distance: "Nearest Fire Station",
  weighbridge_distance: "Nearest Weighbridge",
  bus_stand_distance: "Nearest Bus Stand",
  highway_distance: "Nearest Highway",
  police_station_distance: "Nearest Police Station",
  hospital_distance: "Nearest Hospital",
  town_distance: "Nearest Town",
};

class CompareWarehouse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultActiveKey: 0,
      count: 0,
      warehouses: [],
      warehouses1: [],
      compareParameters: [],
      options: [],
      similarWarehouses: [],
      isloading: false,
      active: 0,
      path: "/",
      setCompareClick: false,
    };

    //  this.onSelect = this.onSelect.bind(this);
    //this.onRemove = this.onRemove.bind(this);
    //  this.addFavorite = this.addFavorite.bind(this);

    this.updateCompareWHCart = this.updateCompareWHCart.bind(this);
    this.onClickRemove = this.onClickRemove.bind(this);
    this.multiselectRef = React.createRef();
  }

  /********************************* Life Cyle Method *****************************************/

  async componentDidMount() {
    FetchOption.getAllOption().then((response) => {
      if (response && response.data && response.data.data)
        this.props.addOption(response.data.data);
    });
    localStorage.setItem("path", JSON.stringify(this.props.location));
    // if (!isLogin()) {
    //     await this.props.addCompareParameter(compareParameters())
    // }
    this.getWarehouseData();
    window.scroll(0, 0);

    this.setState({
      path:
        localStorage.getItem("path") !== ""
          ? JSON.parse(localStorage.getItem("path"))
          : undefined,
    });
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (
      this.props.compareWarehouses !== prevProps.compareWarehouses &&
      !this.state.setCompareClick
    ) {
      this.getWarehouseData();
    }
  }

  /********************************* API Method *****************************************/

  /**
   *
   * @Vishal
   * get compare warehouse data
   */
  async getWarehouseData() {
    const warehouseIdArr = [];
    const { compareWarehouses } = this.props;

    if (compareWarehouses !== undefined) {
      compareWarehouses.forEach((compareWarehouse) => {
        warehouseIdArr.push(compareWarehouse.id);
      });

      if (warehouseIdArr.length > 0) {
        this.similarWarehouses(warehouseIdArr);
        this.setState({ isloading: true });

        let warehouseIds = { warehouse_id: warehouseIdArr };
        let result = await whService.compareWarehouses(warehouseIds);

        if (result && result.data.length < 2) {
          toastr.info("Minimum two warehouses required to Compare");
          this.props.history.push("/warehouse/find-a-warehouse");
        }

        if (result) {
          // let compareParameters = this.props.compareParameters;
          this.setState({
            warehouses: result.data,
            warehouses1: JSON.parse(JSON.stringify(result.data)),
            compareParameters: compareParameters(),
            options: compareParameters(),
            selected: [0, 1],
            isloading: false,
            setCompareClick: false,
          });
        }
      } else {
        toastr.info("Minimum two warehouses required to Compare");
        this.props.history.push("/warehouse/find-a-warehouse");
      }
    }
  }

  handleSelect(e) {
    this.setState({
      defaultActiveKey: e,
      count: e,
    });
  }

  async similarWarehouses(arr) {
    let obj = {
      id: arr,
    };

    let response = await whService.similarWarehouses(obj);
    if (response) {
      this.setState({
        similarWarehouses: response.data,
      });
    }
  }

  updateCompareWHCart(id) {
    if (id) {
      this.state.warehouses.forEach((warehouse, index) => {
        if (warehouse.id === id) {
          let WHCopy = JSON.parse(JSON.stringify(this.state.warehouses));
          WHCopy[index].incart = true;

          this.setState({
            warehouses: WHCopy,
          });
        }
      });
    }
  }

  /********************************* Render Method *****************************************/
  onClickRemove(indexOfWarehouseArray) {
    let id = "";
    if (this.state.warehouses && this.state.warehouses.length > 2) {
      this.setState({
        warehouses: this.state.warehouses.filter((data, index) => {
          if (indexOfWarehouseArray === index) {
            this.props.removeCompare(data);
          } else {
            return true;
          }
        }),
      });
    } else {
      this.setState({
        warehouses: this.state.warehouses.filter((data, index) => {
          if (indexOfWarehouseArray === index) {
            let path =
              this.state.path !== undefined && this.state.path.pathname
                ? this.state.path.pathname
                : "/";
            this.props.removeCompare(data);
            this.props.history.push(path);
          } else {
            return true;
          }
        }),
      });
    }
  }

  onChangeTab = (tab) => {
    this.setState({
      active: tab,
    });
  };

  renderCard = () => {
    let renderArr = [];
    this.state.similarWarehouses.forEach((data, index) => {
      if (this.state.similarWarehouses[index + 1])
        renderArr = [
          ...renderArr,
          <div class="item">
            <div className="new-warehouse-compare-list">
              <div className="wh-display-portion">
                <div className="wh-section-list">
                  <div className="warehoseTiles">
                    <img
                      src={
                        data.multimedia.length !== 0
                          ? data.multimedia[0]
                          : notfound
                      }
                      alt=""
                    />
                  </div>
                  <h4>{data.name}</h4>
                </div>
                <div className="wh-section-list">
                  <div className="warehoseTiles">
                    <img
                      src={
                        data.multimedia.length !== 0
                          ? data.multimedia[0]
                          : notfound
                      }
                      alt=""
                    />
                    <h4>{this.state.similarWarehouses[index + 1]?.name}</h4>
                  </div>
                </div>
              </div>
              <div className="names">
                <a
                  href="#"
                  onClick={() =>
                    this.addCompareData(
                      data,
                      this.state.similarWarehouses[index + 1]
                    )
                  }
                >
                  {data.name} &amp;{" "}
                  {this.state.similarWarehouses[index + 1]?.name}
                </a>
              </div>
            </div>
          </div>,
        ];
    });
    return renderArr;
  };

  addCompareData = (data1, data2) => {
    this.setState(
      {
        setCompareClick: true,
      },
      () => {
        this.props.clearCompare();
        setTimeout(() => {
          const compareData = {
            id: data1.id,
            name: data1.name,
            multimedia: data1.multimedia,
            address: data1.address,
            data: data1,
          };
          this.props.addCompare(compareData);
          const compareData2 = {
            id: data2.id,
            name: data2.name,
            multimedia: data2.multimedia,
            address: data2.address,
            data: data2,
          };
          this.props.addCompare(compareData2);
          this.getWarehouseData();
        }, 100);
      }
    );
  };

  render() {
    const { options_master } = this.props.option;
    const { warehouses } = this.state;
    const isMobile = window.matchMedia(
      "only screen and (max-width: 991px)"
    ).matches;

    const weighbridge = compareConstant.weighbridge;
    const structure = compareConstant.structure;
    const amenities = compareConstant.amenities;

    return (
      <React.Fragment>
        <SetHeader active={"none"} history={this.props.history}></SetHeader>
        <LoaderWithLogo isLoading={this.state.isloading}></LoaderWithLogo>
        {warehouses.length > 0 ? (
          <React.Fragment>
            {isMobile ? (
              <div className="mobBread">
                <div
                  className="customBreadcumb compareBreadcr"
                  style={{ paddingLeft: "40px" }}
                >
                  <Link onClick={() => this.props.history.push("/")}>
                    <MultiLanguageTranslation title="Arya.ag" />
                  </Link>
                  <span>
                    <AiOutlineRight />
                  </span>
                  <Link
                    href="#0"
                    onClick={() =>
                      this.props.history.push("/warehouse/find-a-warehouse")
                    }
                  >
                    <MultiLanguageTranslation title="Listing" />
                  </Link>
                  <span>
                    <AiOutlineRight />
                  </span>
                  <strong>
                    <MultiLanguageTranslation title="Compare" />
                  </strong>
                </div>
              </div>
            ) : (
              <div className="customBreadcumb" style={{ paddingLeft: "40px" }}>
                <Link onClick={() => this.props.history.push("/")}>
                  <MultiLanguageTranslation title="Arya.ag" />
                </Link>
                <span>→</span>
                <Link
                  href="#0"
                  onClick={() =>
                    this.props.history.push("/warehouse/find-a-warehouse")
                  }
                >
                  <MultiLanguageTranslation title="Listing" />
                </Link>
                <span>→</span>
                <strong>
                  <MultiLanguageTranslation title="Compare" />
                </strong>
              </div>
            )}
            <div className="clearfix"></div>
            <div className="new-compare-WHListing">
              <div className="container-fluid" style={{ padding: "0 40px" }}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="warehouse-compare-name">
                      <h3>
                        {warehouses.length > 0 &&
                          warehouses.map((warehouse, index) => {
                            return index === 0
                              ? warehouse.name
                              : " vs " + warehouse.name;
                          })}
                      </h3>
                    </div>
                    <div className="new-warehouse-compare-list">
                      <div className="hide-common-feature-wh">
                        {/* <input type="checkbox" />
                                            <label>Hide Common Features</label> */}
                      </div>
                      <div className="wh-display-portion">
                        {warehouses.length > 0 &&
                          warehouses.map((warehouse, index) => {
                            return (
                              <CompareWarehouseList
                                key={warehouse.id}
                                clsname="col-sm-6 col-lg-3 compareSelectedProducts"
                                warehouse={warehouse}
                                history={this.props.history}
                                updateCompareWHCart={this.updateCompareWHCart}
                                onClickRemove={this.onClickRemove}
                                index={index}
                              ></CompareWarehouseList>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {isMobile ? (
              <div className="mobCompareHouse">
                <Accordion allowZeroExpanded preExpanded={["33"]}>
                  <AccordionItem key="0">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <MultiLanguageTranslation title="Warehouse Availibility" />
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      {options_master.booking_options.map((key) => {
                        return (
                          <>
                            <label>{key.label}</label>
                            <table className="table table-bordered">
                              <tr>
                                {this.state.warehouses &&
                                  this.state.warehouses.map((data) => {
                                    return (
                                      <td className="w-50">
                                        {data &&
                                        data.booking_options &&
                                        data.booking_options.match(key.value)
                                          ? "Available"
                                          : "Not Available"}
                                      </td>
                                    );
                                  })}
                              </tr>
                            </table>
                          </>
                        );
                      })}
                    </AccordionItemPanel>
                  </AccordionItem>

                  <AccordionItem key="1">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <MultiLanguageTranslation title="Brokerage" />
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <table className="table table-bordered">
                        <tr>
                          {this.state.warehouses &&
                            this.state.warehouses.map((data) => {
                              return (
                                <td className="w-50">
                                  {data?.brokerage ? data.brokerage : "NO"}
                                </td>
                              );
                            })}
                        </tr>
                      </table>
                    </AccordionItemPanel>
                  </AccordionItem>

                  <AccordionItem key="2">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <MultiLanguageTranslation title="Warehouse Capacity" />
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      {capacity_wh.map((d) => {
                        let wh1 =
                          this.state.warehouses[0]?.warehouse_capacity[d.key];
                        let wh2 =
                          this.state.warehouses[1]?.warehouse_capacity[d.key];
                        return (
                          <>
                            <label>{d.value}</label>
                            <table className="table table-bordered">
                              <tr>
                                <td className="w-50">{wh1 ? wh1 : "N/A"}</td>
                                <td className="w-50">{wh2 ? wh2 : "N/A"}</td>
                              </tr>
                            </table>
                          </>
                        );
                      })}
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem key="3">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <MultiLanguageTranslation title="Accessibilty" />
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      {
                        <>
                          {Object.keys(accessibility_wh).map((d) => {
                            let wh1 =
                              this.state.warehouses[0]?.accessibility[d];
                            let wh2 =
                              this.state.warehouses[1]?.accessibility[d];
                            return (
                              <>
                                <label>{accessibility_wh[d]}</label>
                                <table className="table table-bordered">
                                  <tr>
                                    <td className="w-50">
                                      {wh1 ? wh1 : "N/A"}
                                    </td>
                                    <td className="w-50">
                                      {wh2 ? wh2 : "N/A"}
                                    </td>
                                  </tr>
                                </table>
                              </>
                            );
                          })}
                        </>
                      }
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem key="4">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <MultiLanguageTranslation title="Warehouse Structure" />
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      {structure &&
                        structure.map((key) => {
                          return (
                            <>
                              <label>{key.key}</label>
                              <table className="table table-bordered">
                                <tr>
                                  {this.state.warehouses &&
                                    this.state.warehouses.map((data) => {
                                      if (
                                        options_master.hasOwnProperty(
                                          key.label
                                        ) &&
                                        key.label !== "built_in_year"
                                      ) {
                                        return (
                                          <>
                                            {options_master &&
                                              options_master[key.label].map(
                                                (option) => {
                                                  if (
                                                    parseInt(option.value) ===
                                                    parseInt(
                                                      data.warehouse_structure[
                                                        key.label
                                                      ]
                                                    )
                                                  ) {
                                                    return (
                                                      <td>{option.label}</td>
                                                    );
                                                  }
                                                }
                                              )}{" "}
                                          </>
                                        );
                                      } else {
                                        return (
                                          <td>
                                            {
                                              data.warehouse_structure[
                                                key.label
                                              ]
                                            }
                                          </td>
                                        );
                                      }
                                    })}
                                </tr>
                              </table>
                            </>
                          );
                        })}
                    </AccordionItemPanel>
                  </AccordionItem>

                  <AccordionItem key="5">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <MultiLanguageTranslation title="Amenities" />
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      {amenities &&
                        amenities.map((key) => {
                          let temp = false;
                          return (
                            <>
                              <label>{key.key}</label>
                              <table className="table table-bordered">
                                {this.state.warehouses1 &&
                                  this.state.warehouses1.map((data) => {
                                    options_master.building_features.map(
                                      (option) => {
                                        if (
                                          data &&
                                          data.amenities &&
                                          data.amenities.building_features.match(
                                            option.value
                                          ) &&
                                          key.label === option.label
                                        ) {
                                          temp = true;
                                        }
                                      }
                                    );
                                    if (
                                      data &&
                                      data.amenities &&
                                      data.amenities.guard_room === "YES" &&
                                      key.label === "guard_room"
                                    ) {
                                      temp = true;
                                    }
                                    if (
                                      data &&
                                      data.amenities &&
                                      data.amenities.safety_manual === "YES" &&
                                      key.label === "safety_manual"
                                    ) {
                                      temp = true;
                                    }
                                    if (
                                      data &&
                                      data.amenities &&
                                      data.amenities.road &&
                                      key.label === "road"
                                    ) {
                                      temp = true;
                                    }
                                    if (
                                      data &&
                                      data.amenities &&
                                      data.amenities.lockin_key &&
                                      key.label === "lockin_key"
                                    ) {
                                      temp = true;
                                    }
                                    if (
                                      data &&
                                      data.amenities &&
                                      data.amenities.lock_in_period &&
                                      key.label === "lock_in_period"
                                    ) {
                                      temp = true;
                                    }
                                    return <td>{temp ? "YES" : "NO"}</td>;
                                  })}
                              </table>
                            </>
                          );
                        })}

                      {/* <label>Main Road Access</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>Minimum Lockin Key</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>Lockin Period</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>Guard</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>NO</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>Safety Manual</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>NO</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>FIRE EXTINGUISHERS</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>OPEN PLINTH</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>SPRINKLER SYSTEM</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>Phone</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>GRADING MACHINE</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>IRON SHEET</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>Fire Bucket</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>Electricity</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>RUNNING WATER</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>NO</td>
                                                <td className='w-50'>NO</td>
                                            </tr>
                                        </table>

                                        <label>DRAIN PIPES</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>DRINKING WATER</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>FIRE/SMOKE DETECTOR</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>Hydrant</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>Singage</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>NO</td>
                                                <td className='w-50'>NO</td>
                                            </tr>
                                        </table>

                                        <label>Lock Key with ARYA</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>

                                        <label>Rodent</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table> */}
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem key="6">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <MultiLanguageTranslation title="License" />
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      {options_master?.license.map((d) => {
                        let wh1 = this.state.warehouses[0]?.license;
                        let wh2 = this.state.warehouses[1]?.license;
                        return (
                          <>
                            <label>{d.label}</label>
                            <table className="table table-bordered">
                              <tr>
                                <td className="w-50">
                                  {wh1?.includes(d.value) ? "YES" : "NO"}
                                </td>
                                <td className="w-50">
                                  {wh2?.includes(d.value) ? "YES" : "NO"}
                                </td>
                              </tr>
                            </table>
                          </>
                        );
                      })}

                      {/* <label>Warehouse License</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>


                                        <label>Fssai License</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>


                                        <label>Wdra License</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>


                                        <label>Procurement License</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>YES</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table> */}
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem key="7">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <MultiLanguageTranslation title="WeightBridge" />
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      {weighbridge &&
                        weighbridge.map((key) => {
                          return (
                            <>
                              <label>{key.key}</label>
                              <table className="table table-bordered">
                                <tr>
                                  {this.state.warehouses &&
                                    this.state.warehouses.map((data) => {
                                      if (key.label === "weighbridge_receipt") {
                                        return options_master.weighbridge_receipt.map(
                                          (option) => {
                                            if (
                                              parseInt(option.value) ===
                                              parseInt(
                                                data.weighbridge[key.label]
                                              )
                                            ) {
                                              return <td>{option.label}</td>;
                                            }
                                          }
                                        );
                                      } else {
                                        return (
                                          <td>{data.weighbridge[key.label]}</td>
                                        );
                                      }
                                    })}
                                </tr>
                              </table>
                            </>
                          );
                        })}

                      {/* <label> Weighbridge Name</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>43</td>
                                                <td className='w-50'>4545</td>
                                            </tr>
                                        </table>
                                        <label> Weighbridge Capacity</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>34 MT</td>
                                                <td className='w-50'>5 MT</td>
                                            </tr>
                                        </table>
                                        <label> Calibration Verified</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>NO</td>
                                                <td className='w-50'>YES</td>
                                            </tr>
                                        </table>
                                        <label> Weighbridge Address</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>43</td>
                                                <td className='w-50'>4545554</td>
                                            </tr>
                                        </table>
                                        <label> Weighbridge Model</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>34</td>
                                                <td className='w-50'>45</td>
                                            </tr>
                                        </table>
                                        <label> Weighbridge Receipt</label>
                                        <table className='table table-bordered'>
                                            <tr>
                                                <td className='w-50'>NO</td>
                                                <td className='w-50'>ELECTRONIC</td>
                                            </tr>
                                        </table> */}
                    </AccordionItemPanel>
                  </AccordionItem>
                </Accordion>
                {Array.isArray(this.state.similarWarehouses) &&
                  this.state.similarWarehouses.length !== 0 && (
                    <div className="moreOption">
                      <h4>Compare With Similar Warehouse</h4>

                      {/* <MultiCarousel items={1.5} loop margin={10} className='owl-theme' dots={false}>
                                    {this.renderCard()}
                              
                              </MultiCarousel>  */}
                      <OwlCarousel
                        className="owl-theme"
                        loop
                        margin={10}
                        items={1.5}
                        dots={false}
                      >
                        {this.renderCard()}
                      </OwlCarousel>
                    </div>
                  )}
              </div>
            ) : (
              <div className="compare-warehouseTab">
                <div className="compare-warehouseTabHeading">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-flex heading-wartab justify-content-between">
                          <Link
                            className={this.state.active === 0 ? "active" : ""}
                            onClick={() => this.onChangeTab(0)}
                          >
                            <MultiLanguageTranslation title="Warehouse Availibility" />
                          </Link>
                          <Link
                            className={this.state.active === 1 ? "active" : ""}
                            onClick={() => this.onChangeTab(1)}
                          >
                            <MultiLanguageTranslation title="Brokerage" />
                          </Link>
                          <Link
                            className={this.state.active === 2 ? "active" : ""}
                            onClick={() => this.onChangeTab(2)}
                          >
                            <MultiLanguageTranslation title="Warehouse Capacity" />
                          </Link>
                          <Link
                            className={this.state.active === 3 ? "active" : ""}
                            onClick={() => this.onChangeTab(3)}
                          >
                            <MultiLanguageTranslation title="Accessibilty" />
                          </Link>
                          <Link
                            className={this.state.active === 4 ? "active" : ""}
                            onClick={() => this.onChangeTab(4)}
                          >
                            <MultiLanguageTranslation title="Warehouse Structure" />
                          </Link>
                          <Link
                            className={this.state.active === 5 ? "active" : ""}
                            onClick={() => this.onChangeTab(5)}
                          >
                            <MultiLanguageTranslation title="Amenities" />
                          </Link>
                          <Link
                            className={this.state.active === 6 ? "active" : ""}
                            onClick={() => this.onChangeTab(6)}
                          >
                            <MultiLanguageTranslation title="License" />
                          </Link>
                          <Link
                            className={this.state.active === 7 ? "active" : ""}
                            onClick={() => this.onChangeTab(7)}
                          >
                            <MultiLanguageTranslation title="WeightBridge" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="compare-WarehouseTabContent">
                        {this.state.compareParameters.length>0 &&
                          this.state.compareParameters.map((parameter) => {
                            if (parameter.value === true) {
                              let data = [];
                              data["key"] = parameter.name;
                              data["datalist"] = [];
                              let index;
                              for (index in warehouses) {
                                // set type of datalist (object and array)

                                if (
                                  typeof warehouses[index][parameter.name] ===
                                  "object"
                                ) {
                                  console.log("sssss4", parameter.name);
                                  if ((data["key"] = "amenities")) {
                                    let dataObject =
                                      warehouses[index][parameter.name];
                                    for (let fieldKey in dataObject) {
                                      if (
                                        fieldKey === "building_features" &&
                                        fieldKey &&
                                        dataObject &&
                                        dataObject[fieldKey]
                                      ) {
                                        let res1 =
                                          dataObject[fieldKey].split(",");
                                        dataObject = setFieldData(
                                          options_master,
                                          fieldKey,
                                          dataObject,
                                          res1
                                        );
                                        delete dataObject[fieldKey];
                                      }
                                    }
                                    data["datalist"].push(dataObject);
                                  } else {
                                    data["datalist"].push(
                                      warehouses[index][parameter.name]
                                    );
                                  }
                                  data["object"] = 1;
                                } else {
                                  if (
                                    options_master.hasOwnProperty(
                                      parameter.name
                                    )
                                  ) {
                                    console.log("sssss3");
                                    let licobj = {};
                                    options_master[parameter.name].map(
                                      (master, keys3) => {
                                        if (parameter.name === "license") {
                                          let res =
                                            warehouses[index][
                                              parameter.name
                                            ].split(",");
                                          if (res.includes(master.value)) {
                                            licobj[master.label] = 1;
                                          } else {
                                            licobj[master.label] = 0;
                                          }
                                        }
                                      }
                                    );
                                    if (parameter.name === "license") {
                                      console.log("sssss2");
                                      data["datalist"].push(licobj);
                                      data["object"] = 1;
                                    }
                                  } else {
                                    console.log("sssss1");
                                    data["datalist"].push(
                                      warehouses[index][parameter.name]
                                    );
                                    data["object"] = 0;
                                  }
                                }
                              }
                              return (
                                <CompareList
                                  warehouses1={this.state.warehouses1}
                                  warehouses={this.state.warehouses}
                                  active={this.state.active}
                                  eventKey={parameter.key}
                                  parameterHdng={parameter.heading}
                                  textual={parameter.textual}
                                  column={parameter.column}
                                  data={data}
                                  clName={
                                    this.state.defaultActiveKey ===
                                    parameter.key
                                      ? "active"
                                      : ""
                                  }
                                ></CompareList>
                              );
                            }
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        ) : (
          <section className="noRecordWrapper">
            <Container>
              <Row>
                <Col lg={12} sm={12}>
                  <div className="noRecord">
                    <h2>No Compare Data Found</h2>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        )}
        <LoginSignupBanner></LoginSignupBanner>
        <WebFooter borderTopCss={true}></WebFooter>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  // add: optionActions.add,
  addCompareParameter: UserDataActions.addCompareParameter,
  removeCompare: UserDataActions.removeCompare,
  addOption: optionActions.addOption,
  clearCompare: UserDataActions.clearCompare,
  addCompare: UserDataActions.addCompare,
};

function mapStateToProps(state) {
  const { option } = state;
  const { compareWarehouses, compareParameters } = state.userData;
  return {
    option,
    compareWarehouses,
    compareParameters,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CompareWarehouse));
